export default __webpack_public_path__ + "static/media/nft.2a563c9e.png";